import script from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"
export * from "./EhTalkChat.vue?vue&type=script&setup=true&lang=js"

import "./EhTalkChat.vue?vue&type=style&index=0&id=7af402a7&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af402a7"]])

export default __exports__